// deps
import React, { memo, ReactElement, ReactNode } from "react";
import classNames from "classnames";

// styles
import styles from "./styles.scss";

//helper
import { withStyles } from "@core-ui/helpers/WithStyles";

interface CommonHeaderContentProps {
    title: ReactNode;
    subtitle?: ReactNode;
    titleLocator?: string;
    subTitleLocator?: string;
    titleClassName?: string;
}

function CommonHeaderContent(props: CommonHeaderContentProps): ReactElement {
    const { title, subtitle } = props;

    const titleClass = classNames(styles.headerTitle, props.titleClassName);

    return (
        <div className={styles.header}>
            <h4 className={titleClass} data-testid={props.titleLocator}>
                {title}
            </h4>

            <div className={styles.headerSubtitle}>
                <span className={styles.headerSubtitleOffer} data-testid={props.subTitleLocator}>
                    {subtitle}
                </span>
            </div>
        </div>
    );
}

export default memo(withStyles(CommonHeaderContent, styles));
